export default "__VITE_ASSET__ifh6ZYOx__"